import { FC, SVGAttributes } from 'react';

import { IMAGES_PATH } from '@telialt/assets/src/constants';

type SpecialPattern = 'transparent' | 'multicolor';

type Props = {
    color: string;
    borderColor: string;
    pattern: SpecialPattern;
    className?: string;
    size?: number;
} & SVGAttributes<SVGSVGElement>;

export const ColoredCircle: FC<Props> = ({ color, borderColor, pattern, size = 18, className, ...rest }) => (
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox={`0 0 ${size} ${size}`}
        fill="none"
        className={className}
        {...rest}
    >
        <circle cx={size / 2} cy={size / 2} r={(size - 2) / 2} fill={color} />
        {!!pattern && (
            <image
                width={size - 2}
                height={size - 2}
                x={(size - (size - 2)) / 2}
                y={(size - (size - 2)) / 2}
                href={`${IMAGES_PATH}/temp/${pattern}-color-badge.svg`}
            />
        )}
        {!!borderColor && (
            <circle cx={size / 2} cy={size / 2} r={(size - 2) / 2} stroke={borderColor} strokeWidth={1} />
        )}
    </svg>
);
